export default {
    RestAPI: {
        Host: String(process.env.VUE_APP_REST_API_DOMAIN),
        Scheme: String(process.env.VUE_APP_REST_API_SCHEME),
        CommonResource: String(process.env.VUE_APP_REST_API_COMMON_RESOURCE),
        Resources: {
            Initialize: String(process.env.VUE_APP_REST_API_COMMON_RESOURCE_INITIALIZE),
        }
    }
}